import { initializeApp } from "firebase/app";
import { getAuth } from "firebase/auth";
import { getStorage } from "firebase/storage";
import { getFirestore } from "firebase/firestore";

const firebaseConfig = {
  apiKey: process.env.REACT_APP_APIKEY,
  authDomain: process.env.REACT_APP_AUTHDOMAIN,
  projectId: process.env.REACT_APP_PROJECTID,
  storageBucket: process.env.REACT_APP_STORAGEBUCKET,
  messagingSenderId: process.env.REACT_APP_MESSAGINGSENDERID,
  appId: process.env.REACT_APP_APPID
};

// 1️⃣ Initialize app FIRST
const app = initializeApp(firebaseConfig);

// Then initialize services
export const auth = getAuth(app);
export const storage = getStorage(app);
export const db = getFirestore(app);


// import { initializeApp, getApps, getApp } from "firebase/app";
// import { getAuth } from "firebase/auth";
// import { getStorage } from "firebase/storage";
// import { getFirestore } from "firebase/firestore";

// const firebaseConfig = {
//   apiKey: process.env.REACT_APP_APIKEY,
//   authDomain: process.env.REACT_APP_AUTHDOMAIN,
//   projectId: process.env.REACT_APP_PROJECTID,
//   storageBucket: process.env.REACT_APP_STORAGEBUCKET,
//   messagingSenderId: process.env.REACT_APP_MESSAGINGSENDERID,
//   appId: process.env.REACT_APP_APPID
// };

// // 1️⃣ Initialize app FIRST
// const app = initializeApp(firebaseConfig);

// // Then initialize services
// export const auth = getAuth(app);
// export const storage = getStorage(app);
// export const db = getFirestore(app);

// const firebaseConfigStore = {
//   apiKey: process.env.REACT_APP_APIKEY_STORE,
//   authDomain: process.env.REACT_APP_AUTHDOMAIN_STORE,
//   projectId: process.env.REACT_APP_PROJECTID_STORE,
//   storageBucket: process.env.REACT_APP_STORAGEBUCKET_STORE,
//   messagingSenderId: process.env.REACT_APP_MESSAGINGSENDERID_STORE,
//   appId: process.env.REACT_APP_APPID_STORE
// };

// // 1️⃣ Initialize app FIRST
// const appStore = getApps().find(a => a.name === "StoreApp") 
//   ? getApp("StoreApp") 
//   : initializeApp(firebaseConfigStore, "StoreApp"); // <-- The explicit name is mandatory here!

// export const authStore = getAuth(appStore);
// export const storageStore = getStorage(appStore);
// export const dbStore = getFirestore(appStore);
